import { ErrorState, Loading } from '@dec/shared';
import ReactHtmlParser from 'react-html-parser';

import { useTaxReturnHeader } from '../../../hooks/useTaxReturnHeader';

export const HeaderPreview = () => {
  const { data: template, isLoading, error, refetch } = useTaxReturnHeader();

  if (isLoading) {
    return <Loading />;
  }
  if (error) {
    return <ErrorState onRetry={() => void refetch()} />;
  }

  return <>{ReactHtmlParser(template?.content ?? '')}</>;
};
